import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-awards-faq',
  templateUrl: './awards-faq.component.html',
  styleUrls: ['./awards-faq.component.scss']
})
export class AwardsFaqComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
